import { otto } from "../../exports/nexus.js";
import { defineEvent, defineStore } from "../nexus/defines.js";
import { hashParams, searchParams } from "./data/params";
import { scope } from "./scope/scope";
import { getCurrentNavigation, initNavigationEvents } from "./lib/navigation";
import { patchHistory } from "./lib/history";
import { NAV_SCOPES } from "./lib/utils";
import { locationState } from "./data/state";
import type { StateRecord } from "./data/state.types";
import type { NavigationScopeOptions, NavigationScopeState } from "./scope/scope.types";
import type { NavigationCurrent } from "./lib/navigation.types";
import { navigate } from "./lib/navigate";
import { initScopes } from "./scope/init";

const [url, state, hash, search] = getCurrentNavigation();

otto.navigation.assignNamespace({
  current: defineStore<NavigationCurrent>({
    url,
    state,
    hash,
    search,
    type: "document",
  }),
  currentUrl: defineStore(url),
  currentState: defineStore(state),
  currentHash: defineStore(hash),
  currentSearch: defineStore(search),
  onNavigate: defineEvent(),

  hashParams,
  searchParams,

  navigate,
  scope,

  /*                                                                          */
  [NAV_SCOPES]: {
    global: {
      onNavigate: defineEvent(),
      current: defineStore<NavigationScopeState<NavigationScopeOptions>>({
        state: locationState<StateRecord>(state),
        hash,
        search,
        type: "push",
        url,
      }),
      currentState: defineStore(locationState<StateRecord>(state)),
      currentHash: defineStore(hash),
      currentSearch: defineStore(search),
    },
  },
});

patchHistory();
initNavigationEvents();

/*                                                                    */
/*                                                                             */
initScopes();

/*                                                                         */
/*                                            */
/*                                     */
/*                                               */
/*  */

/*                                                                     */
/*                                                        */
/*  */
